import React, { createContext, useContext, useState, useEffect } from "react";
import EnquiryModal from "@/components/EnquiryModal";
import { captureSource } from "@/lib/source";

const EnquiryContext = createContext(null);

export const EnquiryProvider = ({ children }) => {
  const [open, setOpen] = useState(false);
  const [prefill, setPrefill] = useState({});
  useEffect(() => { captureSource(); }, []);

  const openEnquiry = (course) => {
    setPrefill(course ? { course_interested: course } : {});
    setOpen(true);
  };

  return (
    <EnquiryContext.Provider value={{ openEnquiry }}>
      {children}
      <EnquiryModal open={open} onOpenChange={setOpen} prefill={prefill} />
    </EnquiryContext.Provider>
  );
};

export const useEnquiry = () => useContext(EnquiryContext);
